import { useEffect } from 'react';
import { UniversalCreateButtonLoadExperience } from './UniversalCreateButtonLoadExperience.tsx';

export const useUniversalCreateLoadExperience = (): void => {
	// Measure time from component mount to button painted on screen
	useEffect(() => {
		UniversalCreateButtonLoadExperience.start();

		// Wait for next paint, then mark as success (measures time until button is visible)
		requestAnimationFrame(() => {
			UniversalCreateButtonLoadExperience.success();
		});
	}, []);
};
